export const shortNumber = (
  number: number | null | undefined,
): string | null => {
  if (number === null || number === undefined || Number.isNaN(number)) {
    return null;
  }

  if (number === 0) {
    return '0';
  }

  const rounder = 10;
  const isNegative = number < 0;

  let abs = Math.abs(number);
  let key = '';

  const powers = [
    { key: 'Q', value: 10 ** 15 },
    { key: 'T', value: 10 ** 12 },
    { key: 'B', value: 10 ** 9 },
    { key: 'M', value: 10 ** 6 },
    { key: 'K', value: 1000 },
  ];

  for (const power of powers) {
    let reduced = abs / power.value;

    reduced = Math.round(reduced * rounder) / rounder;

    if (reduced >= 1) {
      abs = reduced;
      key = power.key;
      break;
    }
  }

  return `${isNegative ? '-' : ''}${abs}${key}`;
};
